/**
 * @name LoadingDots
 * @description Componente común con la animación de puntos de carga 
 * @author Ricardo Guerra
 */

import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoadingDots = () => {
  return (
    <Styled.DotsWrapper>
      <Styled.Dot delay="0s" color="blueMedium" />
      <Styled.Dot delay="0.15s" color="purple" />
      <Styled.Dot delay="0.30s" color="greyDark" />
      <Styled.Dot delay="0.45s" color="red" />
    </Styled.DotsWrapper>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.DotsWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: auto;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

Styled.LoadingAnimation = keyframes`
  0%, 80%, 100% {
    opacity: 0.35;
    transform: translateY(0) scale(0.9);
  }

  40% {
    opacity: 1;
    transform: translateY(-4px) scale(1);
  }
`;

Styled.Dot = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin: 10px;
  background: ${(props) => props.theme.colors[props.color] || props.theme.colors.blueMedium};
  animation: ${Styled.LoadingAnimation} 1.05s ease-in-out infinite;
  animation-delay: ${(props) => props.delay};
  transform-origin: center center;
  will-change: transform, opacity;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.8;
  }
`;

export default LoadingDots;